import React from 'react';
import ContentEditable from 'react-contenteditable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import './ChatInput.component.scss';

export function ChatInputComponent(props: any) {
  const {sendMessage, handleInputChange, message} = props;

  return (
    <div className='chat-input-wrapper d-flex jusntify-content-start align-items-center'>
      <div className='input-container'>
        {
          !message.length && <div className='placeholder-container d-flex justify-content-center align-items-center'>
            <div className='placeholder'><FormattedMessage id='chat.write_a_message'/></div>
          </div>
        }
        <ContentEditable
          className='input'
          html={message}
          disabled={false}
          onChange={(e) => handleInputChange(e)}
        />
      </div>
      <div className='button-send' onClick={() => sendMessage()}>
        <FontAwesomeIcon icon='paper-plane' />
      </div>
    </div>
  );
}
